import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Renderer2 } from '@angular/core';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  title = 'app';
  selected:any='lt';
  position:any;

  constructor(private translate: TranslateService, private renderer: Renderer2) {
     this.position =  this.renderer.listen('window', 'scroll', (evt) => {
        this.scroll1();
       });
    if(localStorage.getItem('lang')){
    this.selected = localStorage.getItem('lang');
    this.translate.setDefaultLang(this.selected);
  } else {
    translate.setDefaultLang('lt')
    }
  }
  langChange(select){
  localStorage.setItem('lang', select);
  this.translate.use(select)
}

scroll1() {
 let toTop = document.getElementById('myBtn');
 window.scrollY > 100 ? toTop.style.display = 'Block' : toTop.style.display = 'none';
}
// go top .ts function, can be used instead of .js function later
// goTop(){
//        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
// }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts